import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {
  IconButton,
  IconButtonOwnProps,
  SvgIconOwnProps,
  Typography,
  TypographyStyle,
} from "@mui/material";
import { BigTooltip } from "components/BigTooltip";
import { useMemo } from "react";

/** Enter and Space activate the button (the browser turns them into a click,
 * which BigTooltip already contains). Parents never see them, so a DataGrid
 * column header doesn't also sort when the button is used from the keyboard.
 * Other keys, like Escape, still reach dialogs and menus around the button. */
function stopActivationKeyPropagation(event: React.KeyboardEvent) {
  if (event.key === "Enter" || event.key === " ") {
    event.stopPropagation();
  }
}

export const InfoIconTooltip = ({
  tooltip,
  fontSize = "inherit",
  iconButtonSx,
  svgIconSx,
  ariaLabel,
}: {
  tooltip: React.ReactNode;
  fontSize?: TypographyStyle["fontSize"];
  iconButtonSx?: IconButtonOwnProps["sx"];
  svgIconSx?: SvgIconOwnProps["sx"];
  /** Names the button for screen readers — it has no text of its own. */
  ariaLabel?: string;
}) => {
  const tooltipDisplayElement = useMemo(() => {
    if (!tooltip) return undefined;
    if (typeof tooltip === "string") {
      return <Typography variant="caption">{tooltip}</Typography>;
    }
    return tooltip;
  }, [tooltip]);
  return (
    <BigTooltip title={tooltipDisplayElement}>
      <IconButton
        size="small"
        aria-label={ariaLabel}
        onKeyDown={stopActivationKeyPropagation}
        sx={{
          ...iconButtonSx,
        }}
      >
        <InfoOutlined
          sx={{
            ...svgIconSx,
            fontSize: fontSize,
          }}
          color="disabled"
        />
      </IconButton>
    </BigTooltip>
  );
};
